export default "__VITE_ASSET__Bs$$vFhK__"